import React from 'react';
import { Header } from '../components/Header';
import { SearchBar } from '../components/SearchBar';
import { AuthorProfile } from '../components/AuthorProfile';
import { PublicationList } from '../components/PublicationList';
export function AuthorPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#4CAF50] selection:text-white" data-id="element-76">
      <Header data-id="element-77" />
      <SearchBar data-id="element-78" />

      <main className="max-w-6xl mx-auto px-4 pb-16" data-id="element-79">
        <AuthorProfile data-id="element-80" />
        <PublicationList data-id="element-81" />
      </main>

      <footer className="w-full border-t border-[#E0E0E0] py-8 mt-12 bg-[#F5F7F8]" data-id="element-82">
        <div className="max-w-6xl mx-auto px-4 text-center text-sm text-gray-500" data-id="element-83">
          <p data-id="element-84">© 2026 EvidentiaMed Academic Repository. All rights reserved.</p>
          <p className="mt-2" data-id="element-85">Data provided for demonstration purposes only.</p>
        </div>
      </footer>
    </div>;
}